export const digitalTransformationConst = {
  path: "/single-programs/digital-transformation",
  title: "ФАКУЛЬТЕТ ИТ И ИНЖЕНЕРИИ – ЦИФРОВАЯ ТРАНСФОРМАЦИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Цифровая трансформация — путь к обновлению бизнеса через технологии</h2>
      <p>
        Цифровая трансформация — это внедрение современных ИТ-решений, которые меняют бизнес-модели, автоматизируют процессы и делают
        компании гибкими и конкурентоспособными. Программа объединяет технологии, управление и стратегию.
      </p>
      <p>
        Студенты учатся оценивать бизнес-процессы, внедрять CRM/ERP-системы, управлять цифровыми проектами, анализировать данные и
        сопровождать изменения в компаниях.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>IT-менеджмент и цифровое лидерство</li>
        <li>Автоматизация бизнес-процессов</li>
        <li>CRM и ERP-системы (SAP, Salesforce, 1C и др.)</li>
        <li>Управление цифровыми проектами (Agile, Scrum, Kanban)</li>
        <li>Анализ и реинжиниринг бизнес-процессов</li>
        <li>Change management и цифровая стратегия</li>
        <li>Цифровая аналитика и визуализация данных</li>
        <li>Основы UX/UI для бизнес-приложений</li>
        <li>Интеграция технологий в корпоративную инфраструктуру</li>
        <li>Безопасность цифровых решений</li>
      </ul>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Менеджер цифровых проектов</li>
        <li>IT-консультант по цифровой трансформации</li>
        <li>Бизнес-аналитик</li>
        <li>Системный интегратор</li>
        <li>Специалист по CRM/ERP</li>
        <li>Продукт-менеджер в ИТ</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€55,000 до €100,000 в год,</strong> в зависимости от сферы и уровня проекта.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Программа, ориентированная на реальные запросы бизнеса</li>
        <li>Работа с популярными цифровыми платформами</li>
        <li>Поддержка в сертификации (PMI, Scrum, Salesforce и др.)</li>
        <li>Преподаватели — эксперты из IT и консалтинга</li>
        <li>Стажировки и кейсы от международных компаний</li>
        <li>Гибкий формат — учитесь из любой точки мира</li>
      </ul>
      <p>Цифровая трансформация — ваш шанс стать ключевым игроком в обновлении бизнеса.</p>
      <h2>Как поступить?</h2>
      <p>Поступление — это просто. Приёмная комиссия поможет вам на всех этапах: от консультации до подачи заявки.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Цифровая трансформация — путь к обновлению бизнеса через технологии
    Цифровая трансформация — это внедрение современных ИТ-решений, которые меняют бизнес-модели, автоматизируют процессы и делают компании гибкими и конкурентоспособными. Программа объединяет технологии, управление и стратегию.
    Студенты учатся оценивать бизнес-процессы, внедрять CRM/ERP-системы, управлять цифровыми проектами, анализировать данные и сопровождать изменения в компаниях.

    Что вы будете изучать?
    • IT-менеджмент и цифровое лидерство
    • Автоматизация бизнес-процессов
    • CRM и ERP-системы (SAP, Salesforce, 1C и др.)
    • Управление цифровыми проектами (Agile, Scrum, Kanban)
    • Анализ и реинжиниринг бизнес-процессов
    • Change management и цифровая стратегия
    • Цифровая аналитика и визуализация данных
    • Основы UX/UI для бизнес-приложений
    • Интеграция технологий в корпоративную инфраструктуру
    • Безопасность цифровых решений

    Кем можно работать после окончания?
    • Менеджер цифровых проектов
    • IT-консультант по цифровой трансформации
    • Бизнес-аналитик
    • Системный интегратор
    • Специалист по CRM/ERP
    • Продукт-менеджер в ИТ

    Средний доход в Европе:
    от €55,000 до €100,000 в год, в зависимости от сферы и уровня проекта.

    Почему выбирают нас?
    • Программа, ориентированная на реальные запросы бизнеса
    • Работа с популярными цифровыми платформами
    • Поддержка в сертификации (PMI, Scrum, Salesforce и др.)
    • Преподаватели — эксперты из IT и консалтинга
    • Стажировки и кейсы от международных компаний
    • Гибкий формат — учитесь из любой точки мира

    Цифровая трансформация — ваш шанс стать ключевым игроком в обновлении бизнеса.

    Как поступить?
    Поступление — это просто. Приёмная комиссия поможет вам на всех этапах: от консультации до подачи заявки.
  `,
};
